export default __webpack_public_path__ + "static/media/aboutImg.08af5e36.jpg";